<template>
  <div>

    <!-- SELECT FORMAT -->
    <div class="text-center" v-if="!form.format">
      <p>{{ $t('select_type_creative') }}</p>
      <div class="mt-4 d-flex flex-column align-items-center mb-4">
        <div class="d-flex flex-column flex-lg-row align-items-center">
          <Button
            class="btn btn-primary mb-3 me-lg-3"
            @click="selectFormat('DISPLAY')"
          >
            {{ $t('creative_format.display') }}
          </Button>
          <Button
            class="btn btn-primary mb-3 me-lg-3"

            @click="selectFormat('DISPLAY_VIDEO')"
          >
            {{ $t('creative_format.display_video') }}
          </Button>
        </div>
        <div class="d-flex flex-column flex-lg-row align-items-center">
          <Button
            class="btn btn-primary text-nowrap  mb-3 me-lg-3"
            @click="selectFormat('NATIVE_DISPLAY')"
          >
            {{ $t('creative_format.native_display') }}
          </Button>
          <Button
            class="btn btn-primary mb-3 me-lg-3"
            @click="selectFormat('PUSH')"
          >
            {{ $t('creative_format.push') }}
          </Button>
        </div>
      </div>
    </div>
    <!-- END SELECT FORMAT -->

    <!-- FORM -->
    <div v-else>
      <div v-for="(creative, index) in form.creatives" :key="index">
        <div :class="{ 'd-flex flex-column flex-lg-row justify-content-lg-center': hasPreview }">

          <form :class="{'col-lg-6': hasPreview }" @submit.prevent="submit" class="text-start default-form">

            <div>
              <!-- FILE -->
              <div class="form-group mb-3" v-if="form.format !== 'YOUTUBE'">
                <div>
                  <label class="form-label fw-bold">
                    {{ $t('creative') }}
                    <label v-if="index >= 1"> n°{{ index + 1 }} </label>
                  </label>
                  <br/>
                </div>
                <input type="file" class="form-control" @change="changeFile($event, index)" :accept="allowedFileTypes" />
                <p class="font-size-xSmall" v-if="form.format === 'NATIVE_DISPLAY' || form.format === 'PUSH'">{{ $t('images_with_a_maximum_size_of_800kb') }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'DISPLAY'">{{ $t('PNG_JPG_or_GIF_with_a_maximum_of_800kb') }}</p>
                <p class="font-size-xSmall" v-else-if="form.format === 'DISPLAY_VIDEO'">{{ $t('MP4_with_a_maximum_of_100MB') }}</p>
                <p class="font-size-xSmall">{{ $t('allowed_dimensions') + allowedLayouts }}</p>
                <p class="font-size-xSmall" v-if="form.creatives[index].fileNotAllowed" style="color: #ff0000;"><strong>{{ $t('attention') }}:</strong> {{ $t('file_has_dimensions_that_are_not_allowed') }}</p>
                <p class="font-size-xSmall" v-if="form.creatives[index].fileDifferentLayout" style="color: #ff0000;"><strong>{{ $t('attention') }}:</strong> {{ $t('file_cannot_have_different_dimensions') }}</p>
              </div>
              <!-- END FILE -->

              <template v-if="form.creatives[index].file">
                <!-- NAME -->
                <div class="form-group mb-3">
                  <label class="form-label fw-bold">{{ $t('name') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('name')" v-model.trim="$v.form.creatives.$each.$iter[index].name.$model" />
                  <p class="font-size-xSmall text-end mt-1 mb-0"
                     :class="{
                      'text-red': $v.form.creatives.$each.$iter[index].name.$model.length > 128
                    }"
                  >{{ `${ $v.form.creatives.$each.$iter[index].name.$model.length }/128` }}</p>
                  <p
                    class="font-size-xSmall fw-bold mt-2 error-message-card"
                    v-if="$v.form.creatives.$each.$iter[index].name.$model.length > 128"
                  >
                    {{ $t('name_cannot_contain_more_than_128_characters') }}
                  </p>
                </div> <!-- END NAME -->
                <!-- URL -->
                <div class="form-group mb-3" v-if="form.format === 'YOUTUBE'">
                  <label class="form-label fw-bold">URL do vídeo no YouTube</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">https://</span>
                    <input type="text" class="form-control" placeholder="www.youtube.com/watch?v=69o-O8WB-NU" v-model.trim="$v.form.creatives.$each.$iter[index].youtube_url.$model" />
                  </div>
                </div> <!-- END URL -->
                <!-- URL -->
                <div class="form-group mb-3">
                  <label class="form-label fw-bold">{{ $t('destination_url') }}</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">https://</span>
                    <input type="text" class="form-control" placeholder="url.com.br" v-model.trim="$v.form.creatives.$each.$iter[index].url.$model" />
                  </div>
                </div> <!-- END URL -->
                <!-- FORMAT -->
                <div class="form-group mb-3">
                  <label class="form-label fw-bold">{{ $t('format') }}</label>
                  <select class="form-control" v-model="$v.form.format.$model" disabled>
                    <option value=""></option>
                    <option :value="format.value" v-for="(format, index) in formatOptions" :key="index">{{ format.label }}</option>
                  </select>
                </div> <!-- END FORMAT -->
                <!-- LAYOUT -->
                <div class="form-group mb-3" v-if="form.format !== 'YOUTUBE'">
                  <label class="form-label fw-bold">{{ $t('size') }}</label>
                  <select class="form-control" v-model="$v.form.creatives.$each.$iter[index].layout.$model" disabled>
                    <option value=""></option>
                    <option :value="layout.value" v-for="(layout, index) in layoutOptions" :key="index">{{ layout.label }}</option>
                  </select>
                </div> <!-- END LAYOUT -->
                <template v-if="form.format === 'NATIVE_DISPLAY' || form.format === 'PUSH'">
                  <!-- LOGO -->
                  <div class="form-group mb-3">
                    <label class="form-label fw-bold">{{ $t('logo') }}</label><br/>
                    <input type="file" @change="changeLogoFile($event, index)" accept="image/*" />
                    <p class="font-size-xSmall">{{ $t('images_with_a_maximum_size_of_800kb') }}</p>
                    <p class="font-size-xSmall">{{ $t('allowed_sizes_200x200') }}</p>
                    <p class="font-size-xSmall" v-if="form.creatives[index].logoFileNotAllowed" style="color: #ff0000;"><strong>{{ $t('attention') }}:</strong> {{ $t('file_has_a_size_that_is_not_allowed') }}</p>
                  </div> <!-- END LOGO -->
                  <!-- ADVERTISER DISPLAY NAME -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('advertisers_display_name') }}</label>
                    <input type="text" class="form-control" :placeholder="$t('title')" v-model.trim="$v.form.creatives.$each.$iter[index].advertiser_display_name.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].advertiser_display_name.length > 25
                      }"
                    >{{ `${ form.creatives[index].advertiser_display_name.length }/25` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].advertiser_display_name.length > 25"
                    >
                      {{ $t('advertiser_display_name_cannot_contain_more_than_25_characters') }}
                    </p>
                  </div> <!-- END ADVERTISER DISPLAY NAME -->
                  <!-- HEADLINE -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('title') }}</label>
                    <input type="text" class="form-control" :placeholder="$t('title')" v-model.trim="$v.form.creatives.$each.$iter[index].headline.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].headline.length > 25
                      }"
                    >{{ `${ form.creatives[index].headline.length }/25` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].headline.length > 25"
                    >
                      {{ $t('title_cannot_contain_more_than_25_characters') }}
                    </p>
                  </div> <!-- END HEADLINE -->
                  <!-- BODY TEXT -->
                  <div class="form-group">
                    <label class="form-label fw-bold">{{ $t('body_text') }}</label>
                    <input type="text" class="form-control" placeholder="Corpo" v-model.trim="$v.form.creatives.$each.$iter[index].body_text.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].body_text.length > bodyTextMaxLength
                      }"
                    >{{ `${ form.creatives[index].body_text.length }/${ bodyTextMaxLength }` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].body_text.length > bodyTextMaxLength"
                    >
                      {{ $t('body_text_cannot_contain_more_than_characters', {value: bodyTextMaxLength}) }}
                    </p>
                  </div> <!-- END BODY TEXT -->
                  <!-- CTA -->
                  <div class="form-group">
                    <label class="form-label fw-bold">
                      {{ $t('call_to_action') }}
                      <span
                        id="cta-tooltip"
                      >
                        <i class="fa fa-info-circle font-size-regular"></i>
                      </span>
                    </label>
                    <b-tooltip target="cta-tooltip">
                      <strong>{{ $t('examples') }}</strong><br/>
                      {{ $t('click_here') }}<br/>
                      {{ $t('learn_more') }}<br/>
                      {{ $t('contact_us2') }}
                    </b-tooltip>
                    <input type="text" class="form-control" :placeholder="$t('learn_more')" v-model.trim="$v.form.creatives.$each.$iter[index].call_to_action.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].call_to_action.length > 15
                      }"
                    >{{ `${ form.creatives[index].call_to_action.length }/15` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].call_to_action.length > 15"
                    >
                      {{ $t('call_to_action_cannot_contain_more_than_15_characters') }}
                    </p>
                  </div> <!-- END CTA  -->
                  <!-- CAPTION URL -->
                  <div class="form-group">
                    <label class="form-label fw-bold">
                      {{ $t('caption_url') }}
                      <span
                        id="cta-caption-url"
                      >
                        <i class="fa fa-info-circle font-size-regular"></i>
                      </span>
                    </label>
                    <b-tooltip target="cta-caption-url">
                      {{ $t('recommend_friendly_version_of_the_landing_page_URL') }}
                    </b-tooltip>
                    <input type="text" class="form-control" placeholder="Saiba mais" v-model.trim="$v.form.creatives.$each.$iter[index].caption_url.$model" />
                    <p class="font-size-xSmall text-end mt-1 mb-0"
                       :class="{
                        'text-red': form.creatives[index].caption_url.length > 30
                      }"
                    >{{ `${ form.creatives[index].caption_url.length }/30` }}</p>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="form.creatives[index].caption_url.length > 30"
                    >
                      {{ $t('display_URL_cannot_be_longer_than_30_characters') }}
                    </p>
                  </div> <!-- END CAPTION URL  -->
                </template>
                <!-- AVAILABILITY -->
                <div class="form-group mb-3" v-if="1 == 2">
                  <label class="form-label fw-bold">{{ $t('availability') }}</label><br/>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-desktop" v-model="form.creatives[index].is_desktop">
                    <label class="form-check-label" for="av-desktop">{{ $t('desktop') }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-mobile" v-model="form.creatives[index].is_mobile">
                    <label class="form-check-label" for="av-mobile">{{ $t('mobile') }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="av-app" v-model="form.creatives[index].is_app">
                    <label class="form-check-label" for="av-app">{{ $t('apps') }}</label>
                  </div>
                </div> <!-- END AVAILABILITY -->

                <!--begin:spacing-->
                <div v-if="form.creatives.length > 1"><hr><br></div>
                <!-- end:spacing-->

              </template>
            </div>
          </form>
          <!-- PREVIEW -->
          <div class="col-lg-6 text-start px-5  mt-5" v-if="hasPreview">
            <h3 class="highlighted-color1 mb-4">
              <span>{{ $t('preview') }}</span>
            </h3>
            <CreativePreviewWrapper
              :advertiser="advertiser"
              :form="form"
              :creative="form.creatives[index]"
              :index="index"
              :isForm="true"
            />
          </div> <!-- END PREVIEW -->
        </div>
        <Button
          v-if="!isCampaignCreationPage && form.creatives.length === 1 || (index !== 0 && index + 1 === form.creatives.length) "
          type="button"
          class="btn btn-sm btn-primary me-3"
          @click="toggleCreative(true)"
          :loading="loader"
        >
          {{ $t('include_more_creatives') }}
        </Button>
        <Button
          v-if="!isCampaignCreationPage && form.creatives.length > 1 && index !== 0 && form.creatives.length === index + 1"
          type="button"
          class="btn btn-sm btn-primary me-3"
          @click="toggleCreative(false)"
          :loading="loader"
        >
          {{ $t('remove_creative') }}
        </Button>
      </div>
      <!-- ACTIONS -->
      <div class="text-center mt-3">
        <!-- MESSAGES -->
        <div
          class="mb-2 alert-message-card text-color2 font-size-small px-3 py-2"
          v-if="loader"
        >
          <p
            class="mb-0"
          >
            {{ $t('this_action_may_take_a_few_minutes') }}
          </p>
        </div> <!-- END MESSAGES -->
        <Button
          type="button"
          class="btn btn-primary me-3"
          @click="submit"
          :loading="loader"
          :disabled="$v.$invalid"
        >
          {{ creative ? $t('edit') : $t('create') }}
        </Button>
      </div> <!-- END ACTIONS -->
    </div> <!-- END FORM -->
  </div>
</template>

<script>

import AdvertisersService from '@/v1/modules/advertisers/services/advertisers-service'
import CreativesService from '@/v1/modules/creatives/services/creatives-service'
import { required, maxLength } from 'vuelidate/lib/validators'
import { CREATIVE_FORMAT_OPTIONS, CREATIVE_LAYOUT_OPTIONS } from '@/v1/modules/helpers/constants/creative-options'

import Button from '@/v1/components/common/Button/Button.vue'
import CreativePreviewWrapper from '@/v1/components/creatives/CreativePreview/CreativePreviewWrapper.vue'

export default {
  name: 'UpsertCreativeForm',
  props: ['advertiserId', 'creative', 'format'],
  components: {
    Button,
    CreativePreviewWrapper
  },
  data () {
    return {
      advertiser: '',
      loader: false,
      form: {
        advertiser_id: '',
        format: '',
        creatives: [
          {
            name: '',
            fileType: '',
            layout: '',
            url: '',
            is_desktop: true,
            is_mobile: true,
            is_app: true,
            file: null,
            logo: null,
            headline: '',
            body_text: '',
            call_to_action: '',
            advertiser_display_name: '',
            caption_url: '',
            youtube_url: '',
            fileNotAllowed: false,
            logoFileNotAllowed: false,
            fileDifferentLayout: false
          }
        ]
      }
    }
  },
  async created () {
    this.form.advertiser_id = this.advertiserId
    if (this.creative) {
      this.form.creatives[0].name = this.creative.name
      this.form.format = this.creative.format
      this.form.creatives[0].layout = this.creative.layout
      this.form.creatives[0].url = this.creative.url.replace('https://', '').replace('http://', '')
      this.form.creatives[0].is_app = this.creative.is_app
      this.form.creatives[0].is_desktop = this.creative.is_desktop
      this.form.creatives[0].is_mobile = this.creative.is_mobile
      this.form.creatives[0].headline = this.creative.headline
      this.form.creatives[0].body_text = this.creative.body_text
      this.form.creatives[0].call_to_action = this.creative.call_to_action
      this.form.creatives[0].advertiser_display_name = this.creative.advertiser_display_name ? this.creative.advertiser_display_name : ''
      this.form.creatives[0].caption_url = this.creative.caption_url ? this.creative.caption_url : ''
    }
    if (this.format) this.form.format = this.format
    await this.getAdvertiser()
  },
  validations () {
    const baseValidations = {
      form: {
        format: { required },
        advertiser_id: { required },
        creatives: {
          $each: {
            name: { required, maxLength: maxLength(128) },
            url: { required },
            // fileType removido, pois é definido automaticamente no changeFile
            file: { required } // Adicionado, pois o upload é essencial
          }
        }
      }
    }

    const validations = baseValidations.form.creatives.$each

    if (this.form.format !== 'YOUTUBE') {
      validations.layout = { required }
    }

    if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'PUSH') {
      validations.advertiser_display_name = { required, maxLength: maxLength(25) }
      validations.headline = { required, maxLength: maxLength(25) }
      validations.body_text = { required, maxLength: maxLength(75) }
      validations.call_to_action = { required, maxLength: maxLength(15) }
      validations.caption_url = { required, maxLength: maxLength(30) }
      validations.logo = { required } // Logo agora obrigatório
    }

    if (this.form.format === 'YOUTUBE') {
      validations.youtube_url = { required }
    }

    if (this.form.format === 'PUSH') {
      validations.body_text = { required, maxLength: maxLength(40) }
    }

    return baseValidations
  },
  computed: {
    /*
     * Check type file
     */
    allowedFileTypes () {
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') return 'image/*'
      else if (this.form.format === 'DISPLAY_VIDEO') return 'video/*'
      return ''
    },
    /**
     * Allowed layouts
     */
    allowedLayouts () {
      const filtered = this.layoutOptions.filter(item => {
        return item.format === this.form.format
      })
      const sizes = filtered.map(item => {
        return item.label
      })
      return sizes.join(', ')
    },
    /**
     * Body text max length
     */
    bodyTextMaxLength () {
      if (this.form.format === 'NATIVE_DISPLAY') return 75
      else if (this.form.format === 'PUSH') return 40
      return 0
    },
    /**
     * Get content type (image or video) of creative
     */
    contentType () {
      if (!this.form.format) return
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') return 'IMAGE'
      else if (this.form.format === 'DISPLAY_VIDEO') return 'VIDEO'
      return ''
    },
    /**
     * All available creative formats
     */
    formatOptions () {
      return CREATIVE_FORMAT_OPTIONS
    },
    /**
     * Check if form has preview
     */
    hasPreview () {
      return this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'PUSH'
    },
    isCampaignCreationPage () {
      return this.$route.name.includes('campaigns')
    },
    /**
     * All available creative layouts
     */
    layoutOptions () {
      return CREATIVE_LAYOUT_OPTIONS
    }
  },
  methods: {
    /**
     * Handle change file
     */
    changeFile (e, index) {
      const file = e.target.files[0]
      if (!file) return
      let element = null
      if (this.form.format === 'NATIVE_DISPLAY' || this.form.format === 'DISPLAY' || this.form.format === 'PUSH') {
        element = new Image()
        element.src = URL.createObjectURL(file)
        element.onload = () => {
          this.validateFileDimension(file, element, index)
        }
      } else if (this.form.format === 'DISPLAY_VIDEO') {
        // Creates a new video element in the HTML document
        element = document.createElement('video')
        // Sets the video source as an object URL created from the 'file' object
        element.src = URL.createObjectURL(file)
        // Create callback
        element.onloadedmetadata = () => {
          this.validateFileDimension(file, element, index)
        }
      }
    },
    /**
     * Handle change logo file
     */
    changeLogoFile (e, index) {
      const file = e.target.files[0]

      // Validate if the file is in allowed layout
      const image = new Image()
      image.src = URL.createObjectURL(file)
      image.onload = () => {
        if (image.width === 200 && image.height === 200) {
          this.form.creatives[index].logoFileNotAllowed = false
          this.form.creatives[index].logo = file
        } else {
          this.form.creatives[index].logoFileNotAllowed = true
          this.form.creatives[index].logo = null
        }
      }
    },
    /**
     * Get advertiser
     */
    async getAdvertiser () {
      try {
        const advertiser = await AdvertisersService.getAdvertiser(this.advertiserId)
        this.advertiser = advertiser
        if (!this.creative) {
          this.form.creatives.map(creative => {
            creative.advertiser_display_name = advertiser.name
          })
          // this.form.advertiser_display_name = advertiser.name
        }
      } catch (error) {

      }
    },
    /**
     * Restart form
     */
    restart (partialReset = false) {
      this.form.name = ''
      this.form.layout = ''
      this.form.url = ''
      this.form.is_desktop = false
      this.form.is_mobile = false
      this.form.is_app = false
      this.form.file = null
      this.form.logo = null
      this.form.headline = ''
      this.form.body_text = ''
      this.form.call_to_action = ''
      this.form.advertiser_display_name = ''
      this.form.caption_url = ''
      if (!partialReset) this.selectFormat('')
    },
    /**
     * Select creative format
     */
    selectFormat (format) {
      this.form.format = format
      this.$emit('format-selected', format)
    },
    /**
     * Submit
     */
    async submit () {
      if (this.$v.$invalid) return
      this.loader = true
      try {
        const form = Object.assign({}, this.form)

        form.creatives = form.creatives.map(creative => {
          // Ajusta URLs
          const adjustedCreative = {
            ...creative,
            url: `https://${creative.url.replace('https://', '').replace('http://', '')}`,
            caption_url: creative.caption_url ? creative.caption_url.replace('https://', '').replace('http://', '') : '',
            youtube_url: creative.youtube_url ? `https://${creative.youtube_url.replace('https://', '').replace('http://', '')}` : ''
          }

          // Limpa campos para DISPLAY e DISPLAY_VIDEO
          if (form.format === 'DISPLAY' || form.format === 'DISPLAY_VIDEO') {
            adjustedCreative.logo = null
            adjustedCreative.headline = ''
            adjustedCreative.body_text = ''
            adjustedCreative.call_to_action = ''
            adjustedCreative.advertiser_display_name = ''
            adjustedCreative.caption_url = ''
          }

          return adjustedCreative
        })

        let creative
        if (this.creative) {
          creative = await CreativesService.updateCreative(this.creative.id, form)
          this.$emit('creative-updated', creative)
        } else {
          creative = await CreativesService.createCreative(form)
          this.$emit('creative-created', creative)
          if (this.format) this.restart(true)
        }
      } catch (error) {
        console.log(error) // Mantive o log para debug
        this.$emit('upsert-creative-error', error)
      }
      this.loader = false
    },
    /**
     * Add or remove creative
     */
    toggleCreative (insert) {
      if (insert) {
        this.form.creatives.push({
          name: '',
          fileType: '',
          layout: '',
          url: '',
          is_desktop: true,
          is_mobile: true,
          is_app: true,
          file: null,
          logo: null,
          headline: '',
          body_text: '',
          call_to_action: '',
          advertiser_display_name: '',
          caption_url: '',
          youtube_url: ''
        })
      } else {
        this.form.creatives.pop()
      }
    },
    /**
     * Validate file dimension
     */
    validateFileDimension (file, element, index) {
      // If creative exists, check if element is different layout
      this.form.creatives[index].fileDifferentLayout = false
      const elementWidth = this.contentType === 'IMAGE' ? element.width : element.videoWidth
      const elementHeight = this.contentType === 'IMAGE' ? element.height : element.videoHeight
      if (this.creative) {
        const dimensions = this.form.creatives[index].layout.split('x')
        if (elementWidth !== parseInt(dimensions[0]) || elementHeight !== parseInt(dimensions[1])) {
          this.form.creatives[index].fileDifferentLayout = true
          return
        }
      }
      let allowed = false
      const filtered = this.layoutOptions.filter(item => {
        return item.format === this.form.format
      })
      filtered.forEach(item => {
        if (elementWidth === item.width && elementHeight === item.height) {
          allowed = true
          this.form.creatives[index].layout = item.value
          this.form.format = item.format
        }
      })
      if (allowed) {
        this.form.creatives[index].file = file
        this.form.creatives[index].fileNotAllowed = false
        // Updates the form name with the file name (without the extension)
        if (!this.form.creatives[index].name) this.form.creatives[index].name = file.name.split('.').slice(0, -1).join('.')
      } else {
        this.form.creatives[index].fileNotAllowed = true
        this.form.creatives[index].file = null
      }
    }
  }
}
</script>
